"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var buffer_1 = require("buffer");

var JwtPayload_1 = require("./JwtPayload");

var Authentication =
/** @class */
function () {
  function Authentication() {
    this.parseToken = function (token) {
      var _a, _b;

      var jwtPayload;
      var base64 = (_b = (_a = token === null || token === void 0 ? void 0 : token.split('.')[1]) === null || _a === void 0 ? void 0 : _a.replace(/-/g, '+')) === null || _b === void 0 ? void 0 : _b.replace(/_/g, '/');

      if (base64) {
        var parsedClaims = JSON.parse(buffer_1.Buffer.from(base64, 'base64').toString('ascii'));
        jwtPayload = new JwtPayload_1.JwtPayload();
        jwtPayload.populate(parsedClaims);
      }

      return jwtPayload;
    };
  }

  return Authentication;
}();

exports["default"] = new Authentication();